
        var result = require("!!../../../../node_modules/css-loader/index.js!./member-logs.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/member-logs/member-logs.component.css
// module id = 618
// module chunks = 0